var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiCrane24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    part: "icon",
    id: "mi-crane",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 2.086A1 1 0 0 1 12.106 2h2.752a1 1 0 0 1 .525.148L21.642 6H22a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3v10h3v1H2v-1h11V11H7v3h2v1H4v-1h2v-3H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h.894L11.7 2.086zM5.356 6H13V3h-.894l-6.75 3zM14 3v3h5.733l-4.875-3H14zm-1 4H2v3h11V7zm1 3h8V7h-8v3zm0 1v4.162l4 1.6V11h-4zm4 6.838l-4-1.6V21h4v-3.162z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiCrane24Px);
export default __webpack_public_path__ + "static/media/mi-crane-24px.8346bed9a45625cb493e88d0dec3b2d1.svg";
export { ForwardRef as ReactComponent };